import React, { useState, useEffect } from 'react';
import { host_url } from '../../App';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import './JobsZuteilen.css';

const JobsZuteilen = () => {
  const [output, setOutput] = useState('');
  const [einheiten, setEinheiten] = useState([]);
  const [selectedEinheit, setSelectedEinheit] = useState('');
  const [loading, setLoading] = useState(false); // Add loading state
  const [feedback, setFeedback] = useState({ message: '', type: '' });

  useEffect(() => {
    const fetchEinheiten = async () => {
      const response = await fetch(`${host_url}/einheiten`);
      const data = await response.json();
      setEinheiten(data);
    };

    fetchEinheiten();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const einheit = formData.get('einheit');
    const einheitName = einheiten.find(e => String(e.ID) === String(einheit))?.Name || 'die gewählte Einheit';

    // Die Verteilung schreibt Zuteilungen und ändert Salty-Scores — nicht umkehrbar.
    // Beim Start wird ausserdem die Bewerbung für diese Einheit automatisch gesperrt.
    if (!window.confirm(`Jobzuweisung für "${einheitName}" wirklich starten?\n\nDie Bewerbung für diese Schicht wird dabei automatisch gesperrt, damit sich keine Kinder mehr bewerben können.\n\nDie Verteilung kann nicht rückgängig gemacht werden.`)) {
      return;
    }

    setLoading(true);
    setFeedback({ message: '', type: '' });
    setOutput('');

    try {
      const response = await fetch(`${host_url}/run-script`, {
        method: 'POST',
        body: JSON.stringify({ einheit }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.text();
      if (!response.ok) {
        setFeedback({ message: result, type: 'error' });
      } else {
        setOutput(result);
      }
    } catch (error) {
      setFeedback({ message: error.message, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/arbeit" />
      <main>
        <h1 className="section-title orange">Jobs zuweisen</h1>
        <form onSubmit={handleSubmit}>
          <label htmlFor="einheit">Einheit</label>
          <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
            <select
              name="einheit"
              id="einheit"
              value={selectedEinheit}
              onChange={e => setSelectedEinheit(e.target.value)}>
              <option value="" disabled>Wähle eine Einheit</option>
              {einheiten.map(einheit => (
                <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
              ))}
            </select>
            <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
          </div>
          <button type="submit" className="button" disabled={loading}> {/* Disable button while loading */}
            {loading ? 'Lädt...' : 'Starte Jobzuweisung'} {/* Show loading text */}
          </button>
        </form>
        {loading && <div className="loading-animation">Wird geladen...</div>}
        {feedback.message && (
          <p className={`feedback ${feedback.type}`}>{feedback.message}</p>
        )}
        {output && (
          <div className="process-notification">
            <p className="process-header">Ergebnis der Verteilung</p>
            <pre className="process-output">{output}</pre>
          </div>
        )}
      </main>
    </div>
    </KernteamLayout>
  );
};

export default JobsZuteilen;
